export const PURCHASE_ORDER_STATUS_OPTIONS = Object.freeze([
  { id: "Created", name: "Created" },
  { id: "Open", name: "Open" },
  { id: "Follow Up", name: "Follow Up" },
  { id: "Submitted", name: "Submitted" },
  { id: "Confirmed", name: "Confirmed" },
  { id: "Shipped", name: "Shipped" },
  { id: "Partially Received", name: "Partially Received" },
  { id: "Received", name: "Received" },
  { id: "Production Scheduled", name: "Production Scheduled" },
  { id: "In Progress", name: "In Progress" },
  { id: "Production Complete", name: "Production Complete" },
  { id: "Ready For Billing", name: "Ready For Billing" },
  { id: "Billed", name: "Billed" },
  { id: "Closed", name: "Closed" },
]);

export const PURCHASE_ORDER_STAGE_LABELS = Object.freeze(
  PURCHASE_ORDER_STATUS_OPTIONS.map((option) => option.id)
);

export const PURCHASE_ORDER_STATUS_RANK = Object.freeze(
  PURCHASE_ORDER_STAGE_LABELS.reduce((ranks, status, index) => {
    ranks[status] = index;
    return ranks;
  }, {})
);

export const PURCHASE_ORDER_IN_PROGRESS_STAGES = Object.freeze([
  "Created",
  "Follow Up",
  "Submitted",
  "Confirmed",
  "Partially Received",
  "Received",
  "Production Scheduled",
]);

export const PURCHASE_ORDER_OPEN_STAGES = Object.freeze(
  PURCHASE_ORDER_STAGE_LABELS.filter((status) => !["Billed", "Closed"].includes(status))
);
